'use client'

import Button, { buttonClassNames } from '@components/primitives/Button'
import { Icon } from '@components/primitives/Icon'
import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight'
import Routes from '@lib/routes'
import DynamicRoutes from '@lib/routes/DynamicRoutes'
import absoluteUrl from '@lib/routes/helpers/absoluteUrl'
import { trackEventWithFacebook } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import { conditionSearch } from '@modules/images/pages'
import Link from 'next/link'
import { useRouter } from 'next/navigation'

export const ConjuredArticleSearchCard = ({ topic }: { topic?: string }) => {
  const router = useRouter()
  const url = topic
    ? absoluteUrl(DynamicRoutes.trialSearchCondition(topic))
    : Routes.search
  const trackDirectoryClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault()
    trackEventWithFacebook(TrackingEvents.ARTICLE_CARD_CLICKED, {
      path: url.toString(),
      source: TrackingSources.ARTICLE,
    })
    router.push(url.toString())
  }

  const heading = `Find Top ${topic ?? ''} Clinical Trials`
  const subheading = 'Choose from over 30,000 active clinical trials.'

  return (
    <div className='relative isolate mt-4 items-center overflow-hidden rounded-2xl border border-neutral200 bg-neutral50 px-4 py-8 shadow-lg md:rounded-3xl md:px-12'>
      <div className='grid grid-cols-1 sm:grid-cols-2'>
        <div>
          <Text element='h4' styleName='h2'>
            {heading}
          </Text>
          <Text
            className='mr-3 whitespace-pre-wrap pb-5 pl-0.5 pt-3 text-neutral600 antialiased'
            element='p'
            styleName='p-small'
          >
            {subheading}
          </Text>
          <Button
            className={classMerge(
              buttonClassNames.legacy.fill.black,
              'w-44 rounded-full sm:mr-2',
            )}
            onClick={(e) => trackDirectoryClick(e)}
          >
            <Text
              className='text-neutral50'
              element='p'
              styleName='p-small'
              value='View Trials'
            />
            <Icon className='ml-2 text-neutral50' icon={faArrowRight} />
          </Button>
        </div>
        <div>
          <div className='hidden max-w-lg flex-none transform pl-8 sm:block '>
            <Link href={url} rel='nofollow'>
              <div
                className={classMerge(
                  'absolute max-h-[255px] overflow-hidden rounded-t-[7px]', // 7px allows us to have an 8px radius with 1px border width
                )}
              >
                <CloudflareImage
                  alt={'Search for clinical trials'}
                  imageId={conditionSearch}
                />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
